import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import PopUp from './components/common/popUp/PopUp';
import FormContext from './components/forms/FormContext';
import { AuthContextProvider } from './store/auth-context';

ReactDOM.render(
  <BrowserRouter>
    <React.Fragment>
      <FormContext>
        <PopUp>
          <AuthContextProvider>
            <App />
          </AuthContextProvider>
        </PopUp>
      </FormContext>
    </React.Fragment>
    ,
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
